import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = { class: "rec-toast__wrapper" };
const _hoisted_3 = ["role", "aria-live"];
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
    key: 0,
    class: "rec-toast__message__secondary"
};
const _hoisted_6 = {
    key: 1,
    class: "rec-toast__buttons"
};
import { computed, onMounted, ref } from "vue";
import SvgIcon from "@/common/components/SvgIcon.vue";
import { ToastType } from "../store/toast-notifications";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ToastNotification',
    props: {
        toast: {
            type: Object,
            required: true
        }
    },
    emits: ["primary-action", "secondary-action", "close-toast"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const isPermanent = computed(() => props.toast.options?.permanent);
        const closeToast = () => {
            if (isPermanent.value)
                return;
            emits("close-toast");
        };
        const primaryAction = () => {
            emits("primary-action");
        };
        const secondaryAction = () => {
            emits("secondary-action");
        };
        // Action-button ref + focus-on-mount when the toast option opts in. Keyboard
        // users (and screen readers) get focus snapped to the Undo button within the
        // toast's auto-dismiss window — see EC word-edit Undo flow.
        const actionButtonRef = ref(null);
        onMounted(() => {
            if (props.toast.options?.focusActionButton) {
                // `preventScroll` avoids the viewport jumping when focus snaps to a
                // toast that mounts off-screen (e.g. long page, toast in a corner).
                actionButtonRef.value?.focus({ preventScroll: true });
            }
        });
        const toastIcon = computed(() => {
            let icon = null;
            const src = props.toast.options?.svgIconSrc || "/svg/svg-defs.svg";
            if (props.toast.type === ToastType.SUCCESS) {
                icon = "icon-check-circle";
            }
            else if (props.toast.type === ToastType.ERROR) {
                icon = "icon-warning-hollow";
            }
            else if (props.toast.type === ToastType.DELETE) {
                icon = "icon-trash";
            }
            else if (props.toast.type === ToastType.FATAL_ERROR) {
                icon = "icon-warning-square-sync";
            }
            // Allow override
            icon = props.toast.options?.svgIcon || icon;
            return icon ? { icon, src } : null;
        });
        // Live-region attrs are bound on the inner message container, not on the
        // clickable <section>, so AT doesn't have to reconcile a live region with
        // interactive descendants (close + action buttons). Error / fatal-error
        // interrupt with role=alert / aria-live=assertive; everything else announces
        // politely via role=status. `srSilent` opts a single toast out entirely (no
        // role, aria-live="off") for low-stakes confirmations whose primary signal
        // is visible.
        const isInterruptive = computed(() => props.toast.type === ToastType.ERROR || props.toast.type === ToastType.FATAL_ERROR);
        const srSilent = computed(() => props.toast.options?.srSilent === true);
        const toastRole = computed(() => (srSilent.value ? undefined : isInterruptive.value ? "alert" : "status"));
        const toastAriaLive = computed(() => (srSilent.value ? "off" : isInterruptive.value ? "assertive" : "polite"));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", {
                class: _normalizeClass(["rec-toast", [
                        'rec-toast',
                        {
                            'rec-toast--type-fatal-error': __props.toast.type === _unref(ToastType).FATAL_ERROR
                        }
                    ]])
            }, [
                (!isPermanent.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "rec-toast__close",
                        "aria-label": _ctx.$t('Close'),
                        onClick: _withModifiers(closeToast, ["stop"])
                    }, [
                        _createVNode(SvgIcon, { icon: "icon-close-3" })
                    ], 8, _hoisted_1))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                    (toastIcon.value)
                        ? (_openBlock(), _createBlock(SvgIcon, {
                            key: 0,
                            icon: toastIcon.value.icon,
                            src: toastIcon.value.src
                        }, null, 8, ["icon", "src"]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        class: "rec-toast__message",
                        role: toastRole.value,
                        "aria-live": toastAriaLive.value
                    }, [
                        _createElementVNode("div", {
                            innerHTML: __props.toast.message
                        }, null, 8, _hoisted_4),
                        (__props.toast.options?.secondaryMessage)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.toast.options.secondaryMessage), 1))
                            : _createCommentVNode("", true)
                    ], 8, _hoisted_3),
                    (__props.toast.options?.actionButtonLabel || __props.toast.options?.secondaryActionButtonLabel)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            (__props.toast.options?.actionButtonLabel)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    ref_key: "actionButtonRef",
                                    ref: actionButtonRef,
                                    type: "button",
                                    class: "btn",
                                    onClick: primaryAction
                                }, _toDisplayString(__props.toast.options?.actionButtonLabel), 513))
                                : _createCommentVNode("", true),
                            (__props.toast.options?.secondaryActionButtonLabel)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "btn btn-dark",
                                    onClick: secondaryAction
                                }, _toDisplayString(__props.toast.options?.secondaryActionButtonLabel), 1))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ], 2));
        };
    }
});
